import { z } from "zod";
import { NOTES_MAX } from "@shared/constants/validation.js";

const FEEDING_FIELD_MAX = NOTES_MAX;

const feedingField = z.string().trim().max(FEEDING_FIELD_MAX).nullable().optional();

/**
 * Upsert schema for a child's feeding & diet profile. All fields optional so
 * partial saves work; null explicitly clears a field. Omitted fields stay
 * `undefined` and the service layer skips them (mirrors care preferences).
 */
export const upsertFeedingSchema = z.object({
  dietType: feedingField,
  restrictions: feedingField,
  likes: feedingField,
  dislikes: feedingField,
  portionNotes: feedingField,
  scheduleNotes: feedingField,
  bottleFormula: feedingField,
  utensilsNotes: feedingField,
});

export type UpsertFeedingInput = z.infer<typeof upsertFeedingSchema>;
